<script setup lang="ts">
import { useSlots } from 'vue';
import type { VChip } from 'vuetify/components';

type VChipProps = InstanceType<typeof VChip>['$props'];

// This fixes the type error when defining props
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IVChipProps extends /* @vue-ignore */ VChipProps {}

const props = defineProps<IVChipProps>();
const slots = useSlots();
</script>

<template>
    <v-chip v-bind="props" :ripple="false">
        <template v-for="(_slot, name) in slots" #[name]="slot">
            <slot :name="name" v-bind="slot"></slot>
        </template>
    </v-chip>
</template>

<style scoped>
.v-chip span {
    font-size: 14px !important;
}
</style>
